import imageManagement from './view/imageManagement.html';

export default {
  base: {
    state: 'input.electronImage.imageManagement',
    config: {
      url: '/imageManagement',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'input.electronImage.imageManagement.list',
      title: '影像查询',
    },
  },
  list: {
    state: 'input.electronImage.imageManagement.list',
    config: {
      url: '/list',
      template: imageManagement,
      controller: 'imageManagementCtrl',
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/input/electronImage/imageManagement/routers.js